import { type Room } from "matrix-js-sdk/src/matrix";
import React, { type JSX, type HTMLAttributes } from "react";

import { roomContextDetails } from "../../../utils/i18n-helpers";

type Props<T extends keyof HTMLElementTagNameMap> = HTMLAttributes<T> & {
    component?: T;
    room: Room;
};

export function RoomContextDetails<T extends keyof HTMLElementTagNameMap>({
    room,
    component,
    ...other
}: Props<T>): JSX.Element {
    const contextDetails = roomContextDetails(room);
    if (contextDetails) {
        return React.createElement(
            component ?? "div",
            {
                ...other,
                "aria-label": contextDetails.ariaLabel,
            },
            [contextDetails.details],
        );
    }

    return <></>;
}
